import { Controller } from '@hotwired/stimulus';

export default class ScrollActiveIntoViewController extends Controller {
  static targets = ['active'];

  connect() {
    if (!this.hasActiveTarget) return;

    const active = this.activeTarget;
    this.element.scrollLeft =
      active.offsetLeft - (this.element.offsetWidth / 2) + (active.offsetWidth / 2);
  }
}
